import { Context, useState } from 'react';

const useContextState = <T>(
  ctxt: Context<T>,
  ...initialValue: (T | (() => T))[]
) => useState<T>(initialValue[0]);
export default useContextState;
